import {Box, Tooltip} from '@mui/material';
import {styled as muiStyled} from '@mui/material/styles';
import {ratingBgColors2} from 'keys/rating';
import {dark} from 'styles/theme';

const AssessmentResultsTrackingStyles = muiStyled(Box)(({ color, theme }) => ({
    overflow: "auto",
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    rowGap: 20,
    '.select-segmentation': {
        '.MuiOutlinedInput-notchedOutline': {
            borderStyle: "dashed !important"
        }
    },
    '.profiles': {
        display: "flex",
        columnGap: 15,
        alignItems: "center"
    },
    '.bar-lines-header': {
        display: "flex",
        flexDirection: "column",
        rowGap: 7
    },
    '.bar-line-filters': {
        display: "flex",
        justifyContent: "space-between",
        columnGap: 10
    },
    '.select-layout': {
        width: 200
    },
    '.compare-label': {
        fontSize: 19,
        fontWeight: "bold"
    },
    '.filters-header': {
    },
    '.select-affiliation-group': {

    },
    '.tabs': {
        flexGrow: 1,
        display: "flex"
    },
    '.header': {
        padding: "0px 8px",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        rowGap: 10
    },
    '.tabs-and-legend': {
        padding: "0px 8px",
        boxSizing: "border-box",
        display: "flex",
        justifyContent: "end",
    },
    '.bar-lines': {
        display: "flex",
        flexDirection: "column",
        rowGap: 22
    },
    '.view-type-btns': {
        display: "flex",
    },
    '.expected-rating-line': {
        background: "#E4F2D1",
        color: "#50B02B",
    },
    '.unexpected-rating-line': {
        background: "#FBD9DA",
        color: "#FF9B9B",
    },
}));

const DoughnutChartStyles = muiStyled(Box)(({ color, theme }) => ({
    display: "flex",
    flexDirection: "column",
    rowGap: 5,
    '.doughnut': {
        width: 150,
        height: 150,
    },
    '.title': {
        fontWeight: "bold"
    }
}));

const CustomAutoCompleteStyles = muiStyled(Box)(({ width, theme }) => ({
    '.MuiAutocomplete-inputRoot': {
        background: "#FFF !important",
        borderRadius: "30px !important",
        padding: "0px !important",
        paddingLeft: "5px !important",
        borderColor: "#E3E8F0 !important",
        // בלי זה השדה גדל/עוטף שורה כשהתוכן ארוך במקום לחתוך בשלוש נקודות
        overflow: "hidden",
        flexWrap: "nowrap !important"
    },
    '.MuiFormLabel-root.MuiInputLabel-root': {
        display: "none"
    },
    '.MuiFormControl-root.MuiTextField-root': {
        minWidth: width ? `${width}px !important` : "140px !important",
        maxWidth: width ? `${width}px !important` : "220px !important"
    }

}));

const HeaderStyles = muiStyled(Box)(({ color, theme }) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    rowGap: 8,
    ".semester-and-year .MuiOutlinedInput-notchedOutline": {
        border: "none !important"
    },
    ".semester-and-year .MuiAutocomplete-inputRoot": {
        background: "transparent !important"
    },
    '.vertical-line': {
        height: 24,
        width: 1,
        background: "#7E8A9E",
    },
    '.label': {
        // fontSize: 20,
        whiteSpace: "nowrap"
    },
    '.segmentation': {
        width: 260
    },
    '.filters': {
        display: "flex",
        alignItems: "center",
        columnGap: 10
    },
    '.filters-row': {
        display: "flex",
        columnGap: 10,
        alignItems: "center",
        width: "100%",
        paddingTop: 5,
        overflowX: "auto",
    },
    '.btn-text': {
        color: `${dark} !important`
    }
}));


export const LegendStyles = muiStyled(Box)(({ color, theme }) => ({
    display: "flex",
    '.rating-list': {
        display: "flex",
        columnGap: 20,
        justifyContent: "flex-end",
    },
    '.rating-item': {
        display: "flex",
        alignItems: "center",
        columnGap: 8
    },
    '.rating-dot': {
        width: 15,
        height: 15,
        borderRadius: 30
    },
    '.rating-label': {
        fontWeight: "bold"
    },
}));

export const CustomTooltip = muiStyled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    borderRadius: 15,
    boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 18.2px 0px",
    border: "1px solid #CBE1FF",
    backgroundColor: 'white',
    color: 'black',
    padding: theme.spacing(1),
    '.MuiTooltip-tooltip': {
        background: "white",
        color: dark
    }
}));


export const BarLineStyles = muiStyled(Box)(({ ratingItem, isProfileLayout, rating1, rating2, rating3, rating4, rating5, segmentation, expectedMale, expectedFemale, unexpectedFemale, unexpectedMale, isLearningCenter, expected, unexpected }) => ({
    flexGrow: 1,
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    rowGap: 8,
    '.wrap-bar': {
        width: "100%",
        display: "flex",
        columnGap: 15,
        alignItems: "center",
        boxSizing: "border-box",
    },
    '.affiliation-details': {
        width: 170
    },
    '.divider': {
        width: 4,
        height: 12,
        background: "white"
    },
    '.percent': {
        position: "relative",
        top: segmentation && 10,
        display: "block",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
    '.segmentation': {
        width: "100%",
        display: "flex",
        position: "relative",
        bottom: 3,
        top: isLearningCenter && 26,
        alignItems: "end"
    },
    '.dashed': {
        display: "flex",
        columnGap: 2,
        borderBottomWidth: 3,
        borderBottomStyle: "dashed",
        justifyContent: "center",
        '.MuiSvgIcon-root': {
            position: "relative",
            top: 3
        }
    },
    '.male': {
        borderColor: "#539CE4"
    },
    '.female': {
        borderColor: "#F786CA"
    },
    '.new-immigrant': {
        borderColor: "#5A2474"
    },
    '.old-immigrant': {
        borderColor: "#1577FF"
    },
    '.expected-rating-line': {
        background: isProfileLayout && ratingItem?.bg,
        color: isProfileLayout && dark,
        width: `${expected}%`,
    },
    '.unexpected-rating-line': {
        background: isProfileLayout && "#F2F4F7",
        color: isProfileLayout && dark,
        width: `${unexpected}%`
    },
    '.rating1': {
        width: `${rating1}%`,
        background: ratingBgColors2[1]
    },
    '.rating2': {
        width: `${rating2}%`,
        background: ratingBgColors2[2]
    },
    '.rating3': {
        width: `${rating3}%`,
        background: ratingBgColors2[3]
    },
    '.rating4': {
        width: `${rating4}%`,
        background: ratingBgColors2[4]
    },
    '.rating5': {
        width: `${rating5}%`,
        background: ratingBgColors2[5]
    },
    '.rating_1': {
        width: `${rating1}%`,
        background: ratingBgColors2[1]
    },
    '.rating_2': {
        width: `${rating2}%`,
        background: ratingBgColors2[2]
    },
    '.rating_3': {
        width: `${rating3}%`,
        background: ratingBgColors2[3]
    },
    '.rating_4': {
        width: `${rating4}%`,
        background: ratingBgColors2[4]
    },
    '.rating_5': {
        width: `${rating5}%`,
        background: ratingBgColors2[5]
    },
    '.bar-line': {
        display: "flex",
        width: "100%",
        textAlign: "start",
        height: 40,
        boxSizing: "border-box",
    },
    '.basic-layout': {
        direction: "ltr"
    },
    '.profiles-view': {
        direction: "ltr"
    },
    '.profile-layout': {
        direction: "rtl"
    },
    '.bar-line-item': {
        padding: 8,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        overflow: "hidden",
        minWidth: 0,
    },
}));

export { CustomAutoCompleteStyles, HeaderStyles, DoughnutChartStyles, AssessmentResultsTrackingStyles }
